// extracted by mini-css-extract-plugin
export var container = "style-module--container--e2e5d";
export var decide = "style-module--decide--28fac";
export var info = "style-module--info--630a8";
export var innerList = "style-module--inner-list--28746";
export var learn = "style-module--learn--5049b";
export var learnInfo = "style-module--learn-info--1703b";
export var mainList = "style-module--main-list--f0aba";